import root from 'window-or-global';

/**
 * When the tablet or mobile menus are active we want the body to have overflow:hidden and then to replace it
 *     when the menus are closed.
 * @param {Boolean} hide
 */
let bodyOverflowOverridden = false;

export default function setBodyOverflow(hide) {
    if ((bodyOverflowOverridden && hide) || (!bodyOverflowOverridden && !hide)) return;
    const className = ' egh-hide-overflow';

    if (hide) {
        root.document.body.className += className;
        bodyOverflowOverridden = true;
    } else {
        root.document.body.className = root.document.body.className.replace(className, '');
        bodyOverflowOverridden = false;
    }
}
